import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../../tailwind.config.js';

const fullConfig = resolveConfig(tailwindConfig);

export default {
  data() {
    return {
      showMenu: false
    };
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize: function() {
      if (window.innerWidth >= parseInt(fullConfig.theme.screens.sm, 10) && this.showMenu) {
        this.showMenu = false;
      }
    }
  }
};
